import VoltalisStatusRefresh from '../../AdditionalSales/sales/LeadVoltalisBizdevSale/Bones/VoltalisStatusRefresh'
import {
  areAttestationsDone,
  isAppointmentSent,
  isQuoteSigned,
  type VoltalisStatusData,
} from '../../AdditionalSales/sales/LeadVoltalisBizdevSale/voltalisStatus'
import { defaultSaleStatus, defineSaleProgress, isSaleCreated, type ProgressSaleData } from '../saleProgress'

type VoltalisBizdevData = ProgressSaleData &
  VoltalisStatusData & {
    surface?: string | number | null
    heaterCount?: string | number | null
    constructionYear?: string | number | null
  }

const PROGRESS = 'additionalSales:leadVoltalisBizdev.progress.'

export default defineSaleProgress<VoltalisBizdevData>({
  kind: 'sale',
  steps: [
    { key: 'attestations', label: `${PROGRESS}attestations`, done: areAttestationsDone },
    { key: 'created', label: 'additionalSales:pulse.timeline.created', done: isSaleCreated },
    { key: 'quote_signed', label: `${PROGRESS}quote_signed`, done: isQuoteSigned },
    { key: 'appointment', label: `${PROGRESS}appointment`, done: isAppointmentSent },
  ],
  status: (data, steps) => {
    const status = defaultSaleStatus(data, steps)
    const answered =
      Object.keys(data.scriptSteps ?? {}).length > 0 || !!data.surface || !!data.heaterCount || !!data.constructionYear

    return status === 'new' && answered ? 'progress' : status
  },
  doneLabel: `${PROGRESS}done`,
  waitLabel: data => `${PROGRESS}${isQuoteSigned(data) ? 'waiting_appointment' : 'waiting_quote'}`,
  waitActions: VoltalisStatusRefresh,
})
